var map = {
	"./city": 9919,
	"./city.json": 9919,
	"./country": 2449,
	"./country.json": 2449,
	"./lang/en": 2983,
	"./lang/en.json": 2983,
	"./lang/sv": 6098,
	"./lang/sv.json": 6098,
	"./lang/zh": 2011,
	"./lang/zh.json": 2011,
	"./page0": 3834,
	"./page0.json": 3834,
	"./page1": 5896,
	"./page1.json": 5896,
	"./page2": 1638,
	"./page2.json": 1638,
	"./page3": 2672,
	"./page3.json": 2672,
	"./page4": 1265,
	"./page4.json": 1265,
	"./page5": 5898,
	"./page5.json": 5898,
	"./page6": 587,
	"./page6.json": 587,
	"./title": 7033,
	"./title.json": 7033,
	"./work": 8504,
	"./work.json": 8504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7195;